var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6539"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 6538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.4796 8.79177C28.4739 8.76395 28.4636 8.73811 28.4557 8.71128C28.4456 8.67658 28.4375 8.64163 28.4237 8.60816C28.4104 8.57641 28.3924 8.54761 28.376 8.51759C28.3617 8.49125 28.3501 8.46393 28.3331 8.43883C28.2974 8.38542 28.2568 8.33546 28.2118 8.29017C28.2113 8.28968 28.2108 8.28894 28.2108 8.28894C28.165 8.24316 28.1146 8.20231 28.0607 8.16637C28.0366 8.15013 28.0105 8.13905 27.9851 8.12527C27.9541 8.10829 27.9241 8.08958 27.8911 8.0758C27.8586 8.06226 27.8246 8.05463 27.7912 8.04479C27.7631 8.03667 27.7363 8.02584 27.7075 8.01993C27.6437 8.00738 27.5793 8.00049 27.5148 8.00049H20.555C20.0113 8.00049 19.5705 8.44129 19.5705 8.98497C19.5705 9.52865 20.0113 9.96945 20.555 9.96945H25.1382L13.3879 21.719C13.0035 22.1034 13.0035 22.7269 13.3879 23.1111C13.5802 23.3033 13.8322 23.3995 14.0842 23.3995C14.3362 23.3995 14.588 23.3033 14.7805 23.1111L26.53 11.3615V15.9448C26.53 16.4885 26.9708 16.9293 27.5145 16.9293C28.0582 16.9293 28.499 16.4885 28.499 15.9448V8.98497C28.499 8.92024 28.4921 8.85551 28.4796 8.79177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.5155 20.547C26.9718 20.547 26.531 20.9878 26.531 21.5315V25.1344C26.531 26.1802 25.6802 27.031 24.6342 27.031H11.3656C10.3198 27.031 9.46897 26.1802 9.46897 25.1344V11.8656C9.46897 10.8198 10.3198 9.96897 11.3656 9.96897H15.0365C15.5801 9.96897 16.0209 9.52816 16.0209 8.98448C16.0209 8.4408 15.5801 8 15.0365 8H11.3656C9.23417 8 7.5 9.73417 7.5 11.8656V25.1342C7.5 27.2656 9.23417 28.9998 11.3656 28.9998H24.6342C26.7658 28.9998 28.5 27.2656 28.5 25.1342V21.5312C28.5 20.9875 28.0592 20.547 27.5155 20.547Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.ad0a88731d9806f94d5932fd95781887.svg";
export { ForwardRef as ReactComponent };